<script setup>
defineOptions({ inheritAttrs: false })
const props = defineProps({
	route: { type: Object, default: null },
	link: { type: Object, default: null },
	text: { type: String, default: '' }
})
</script>

<template>
	<li role="menuitem">
		<router-link
			v-if="props.route"
			:to="props.route"
			tabindex="-1"
			v-bind="$attrs"
		>
			<slot />
		</router-link>
		<a
			v-if="props.link"
			:href="props.link.href"
			:target="props.link?.target ?? '_self'"
			tabindex="-1"
			v-bind="$attrs"
		>
			<slot />
		</a>
	</li>
</template>
